//
// footer.js
// Theme module for global footer
//
import { client, getSanityEditLink } from './sanity-client';

async function fetchFooterSettings() {
    try {
        const query = `*[_type == "contact"][0]{ _id, socialLinks }`;
        const data = await client.fetch(query);
        return data ? { id: data._id, links: data.socialLinks } : null;
    } catch (error) {
        console.error('Error fetching footer settings:', error);
        return null;
    }
}

function renderFooterSocials(footerData) {
    if (!footerData || !footerData.links) return;

    const socialLinks = footerData.links;
    const docId = footerData.id;

    let hasLink = false;

    if (socialLinks.linkedin) {
        const linkedinLink = document.getElementById('footer-linkedin-link');
        if (linkedinLink) {
            linkedinLink.href = socialLinks.linkedin;
            hasLink = true;
        }
    }

    if (socialLinks.youtube) {
        const youtubeLink = document.getElementById('footer-youtube-link');
        if (youtubeLink) {
            youtubeLink.href = socialLinks.youtube;
            hasLink = true;
        }
    }

    // Add a single edit button for all social links
    if (hasLink && docId) {
        const socialContainer = document.querySelector('.list-social');
        if (socialContainer && !socialContainer.parentElement.querySelector('.sanity-edit-btn')) {
            const editLink = getSanityEditLink(docId, 'contact', 'socialLinks', 'Edit Social Links');
            if (editLink) {
                socialContainer.parentElement.classList.add('position-relative');
                // Move the button up by overriding top inline
                const positionedEditLink = editLink.replace('class="sanity-edit-btn"', 'class="sanity-edit-btn" style="top: -2.5rem; right: 0.5rem;"');
                socialContainer.insertAdjacentHTML('afterend', positionedEditLink);
            }
        }
    }
}

// Initialize global footer logic
document.addEventListener('DOMContentLoaded', async () => {
    // We only fetch these once per page load to populate global elements like the footer
    const data = await fetchFooterSettings();
    renderFooterSocials(data);
});
